var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.488 29.523A5.244 5.244 0 0 0 42 27.106V10a5.006 5.006 0 0 0-5-5h-8.278A1.993 1.993 0 0 0 27 4h-1.341a6 6 0 0 0-11.318 0H13a1.993 1.993 0 0 0-1.722 1H5a5.006 5.006 0 0 0-5 5v42a5.006 5.006 0 0 0 5 5h17.559c.046.094.083.191.135.283A5.217 5.217 0 0 0 27.3 60h27.41a5.218 5.218 0 0 0 4.6-2.718 5.345 5.345 0 0 0-.115-5.473ZM40 10v17.106a5.182 5.182 0 0 0-2 .843V11a2 2 0 0 0-2-2h-7V7h8a3 3 0 0 1 3 3ZM13 6h2.1a1 1 0 0 0 .981-.8 4 4 0 0 1 7.838 0 1 1 0 0 0 .981.8H27v4H13Zm14 6a1.993 1.993 0 0 0 1.722-1H36v19.357L23.3 51H6V11h5.278A1.993 1.993 0 0 0 13 12ZM5 55a3 3 0 0 1-3-3V10a3 3 0 0 1 3-3h6v2H6a2 2 0 0 0-2 2v40a2 2 0 0 0 2 2h16.263a5.3 5.3 0 0 0-.245 2Zm52.561 1.307A3.243 3.243 0 0 1 54.705 58H27.3a3.241 3.241 0 0 1-2.855-1.692 3.371 3.371 0 0 1 .071-3.453l13.7-22.283a3.254 3.254 0 0 1 5.57 0l13.7 22.285a3.369 3.369 0 0 1 .075 3.45Z",
    fill: "#b7b7b7",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 33a3 3 0 0 0-3 3v9a3 3 0 0 0 6 0v-9a3 3 0 0 0-3-3Zm1 12a1 1 0 0 1-2 0v-9a1 1 0 0 1 2 0ZM41 50a3 3 0 1 0 3 3 3 3 0 0 0-3-3Zm0 4a1 1 0 1 1 1-1 1 1 0 0 1-1 1ZM20 19h13a1 1 0 0 0 0-2H20a1 1 0 0 0 0 2ZM20 23h6a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2ZM20 30h13a1 1 0 0 0 0-2H20a1 1 0 0 0 0 2ZM20 34h6a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2ZM20 41h7a1 1 0 0 0 0-2h-7a1 1 0 0 0 0 2ZM20 45h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2ZM9.293 21.293a1 1 0 0 0 0 1.414l2 2A1 1 0 0 0 12 25a.959.959 0 0 0 .16-.013 1 1 0 0 0 .735-.54l4-8a1 1 0 1 0-1.79-.894l-3.379 6.759-1.019-1.019a1 1 0 0 0-1.414 0ZM16.447 26.105a1 1 0 0 0-1.342.448l-3.379 6.759-1.019-1.019a1 1 0 0 0-1.414 1.414l2 2A1 1 0 0 0 12 36a.959.959 0 0 0 .16-.013 1 1 0 0 0 .735-.54l4-8a1 1 0 0 0-.448-1.342ZM16.447 37.1a1 1 0 0 0-1.342.448l-3.379 6.759-1.019-1.019a1 1 0 0 0-1.414 1.414l2 2A1 1 0 0 0 12 47a.959.959 0 0 0 .16-.013 1 1 0 0 0 .735-.54l4-8a1 1 0 0 0-.448-1.347Z",
    fill: "#b7b7b7",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluation);
export default __webpack_public_path__ + "static/media/evaluation.9006a400f26a065aabc55a408f07f5dc.svg";
export { ForwardRef as ReactComponent };